import { gql } from '@apollo/client';

export const LOGS = gql`
  query LogEntries($data: LogEntriesRequestParams!) {
    logEntries(data: $data) {
      results {
        id
        created
        entityId
        entityType
        message
        user {
          name
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const COMMENTS = gql`
  query Comments($params: CommentsRequestParams!) {
    comments(params: $params) {
      results {
        id
        created
        entityId
        entityType
        message
        user {
          name
          id
        }
      }
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation CreateComment($params: CommentParams!) {
    createComment(params: $params) {
      id
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation DeleteComment($id: Int!) {
    deleteComment(id: $id)
  }
`;

export const RECORD_PAGE_VIEW = gql`
  mutation RecordPageView($params: RecordPageViewParams!) {
    recordPageView(params: $params)
  }
`;

export const PAGE_VIEWS = gql`
  query PageViews($params: PageViewParams!) {
    pageViews(params: $params) {
        userName
        recordedAt
    }
  }
`;
